import { Injectable } from '@angular/core'
import { MbCartMigrationAdapter } from './mb-cart-migration.adapter'
import { MbCartMigrationContext } from '../../../models'

@Injectable({
  providedIn: 'root',
})
export class MbCartMigrationConnector {

  constructor (protected adapter: MbCartMigrationAdapter) {
  }

  post (userID: string, cartMigrationInfo: MbCartMigrationContext) {
    return this.adapter.post(userID, cartMigrationInfo)
  }
}
